import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import { Search } from "lucide-react";
import { useResponsiveStyles } from "../../../styles/useResponsiveStyles";
export const MultiSelectSearch = ({ value, onChange }) => {
    const {getFontSize} = useResponsiveStyles()
  return (
    <TextField
      fullWidth
      size="small"
      variant="outlined"
      placeholder="Search Columns"
      className="italic"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search size={12} />
          </InputAdornment>
        ),
      }}
      sx={{
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#ef4444",
          },
        "& .MuiInputBase-input": {
            ...getFontSize('body1'), // Decreased placeholder font size
        },
      }}
    />
  );
};
